export default {
    name: '姓名',
    tel: '電話',
    save: '保存',
    confirm: '確認',
    cancel: '取消',
    delete: '刪除',
    complete: '完成',
    loading: '加載中...',
    telEmpty: '請填寫電話',
    nameEmpty: '請填入你的名字',
    nameInvalid: '請輸入有效的名字',
    confirmDelete: '你確定要刪除嗎',
    telInvalid: '請輸入正確的電話號碼',
    vanCalendar: {
        end: '結束',
        start: '開始',
        title: '標題',
        confirm: '確認',
        startEnd: '開始 結束',
        weekdays: ['日', '一', '二', '三', '四', '五', '六'],
    },
    vanCascader: {
        select: '請選擇',
    },
    vanContactCard: {
        addText: '添加聯繫人',
    },
    vanContactList: {
        addText: '新聯繫人',
    },
    vanPagination: {
        prev: '上一頁',
        next: '下一頁',
    },
    vanPullRefresh: {
        pulling: '下拉刷新...',
        loosing: '釋放刷新...',
    },
    vanSubmitBar: {
        label: '全部：',
    },
    vanCoupon: {
        unlimited: '沒有使用限制',
    },
    vanCouponCell: {
        title: '優惠券',
        tips: '無法使用',
    },
    vanCouponList: {
        empty: '沒有優惠券',
        exchange: '兌換',
        close: '沒有優惠券',
        enable: '可用的',
        disabled: '無法使用',
        placeholder: '請輸入優惠碼',
    },
    vanAddressEdit: {
        area: '區域',
        postal: '郵政編碼',
        areaEmpty: '選擇地區',
        addressEmpty: '請填寫詳細地址',
        postalEmpty: '郵政編碼格式不正確',
        defaultAddress: '設置為默認送貨地址',
        telPlaceholder: '收貨人手機號碼',
        namePlaceholder: '收貨人姓名',
        areaPlaceholder: '選擇省/市/區',
    },
    vanAddressEditDetail: {
        label: '地址',
        placeholder: '街道門牌號、樓層房間號等信息',
    },
    vanAddressList: {
        add: '添加地址',
    },
};
